import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import DateTime from 'react-datetime'
import MultiSelect from "react-multi-select-component";
import SampleExcel from '../../../images/marksSample.xls';
import MarksExcelContainer from './marksExcelContainer';
import { ExcelRenderer } from 'react-excel-renderer';
import * as Cookies from "es-cookie";
import './_studentMarks.scss';
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";
import { getAuthorizedBranchIds } from "../../utils/authHelper";

// /student/marks-upload → "offline_marks_uploading". Match on module_key only.
// The section that opens this modal already gates the opener; this file re-checks at the
// excel pick and the submit, because that's where the write actually happens.
const MARKS_UPLOAD_MODULE = ["offline_marks_uploading"];


const ADD_Marks = gql`
  mutation($params: OfflineStudentResults) {
    addOfflineStudentResults(params: $params)
  }`


class CreateExamModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue: 0,
            section: "",
            class: "",
            exam: "",
            branch: "",
            branchError: "",
            classError: "",
            examError: "",
            sectionError: "",
            submitError: "",
            examName: "",
            examNameError: "",
            startdate: "",
            dateError: "",
            rows: [],
            cols: [],
            dataClear: 0,
            examType: "",
            examTypeError: "",
            subjectValue: [],
            sectionValue: [],
            qbsearchsubject: [],
            offlinesubjectsArray: [],
            StudentsMarksData: [],
            fileError: "",
            marksArray: [],
            loadingSpinner: 0,
            currentStep: 1,
            marksError: "",
            examCategoryData: [],
            getExams: [],
            getClasses: [],
            getSections: [],
            btn_disabled: false,
            accessDeniedShow: false,
        }

        // NOTE: componentDidUpdate below re-seeds a copy of this state literal every time
        // `show` flips to true. accessDeniedShow is deliberately absent from that reset,
        // so it survives — set it here in the constructor only.
        this.guard = attachModuleGuard(this, MARKS_UPLOAD_MODULE);
    }


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                defaultvalue: 0,
                section: "",
                class: "",
                exam: "",
                branch: "",
                branchError: "",
                classError: "",
                examError: "",
                sectionError: "",
                submitError: "",
                examName: "",
                examNameError: "",
                startdate: "",
                dateError: "",
                rows: [],
                cols: [],
                dataClear: 1,
                examType: "",
                examTypeError: "",
                subjectValue: [],
                sectionValue: [],
                qbsearchsubject: [],
                offlinesubjectsArray: [],
                StudentsMarksData: [],
                fileError: "",
                marksArray: [],
                loadingSpinner: 0,
                currentStep: 1,
                marksError: "",
                examCategoryData: [],
                getExams: [],
                getClasses: [],
                getSections: [],
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

 

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
      
        let getArray = [];

        if (name == "branch") {

            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({ branch: value, getExams: getArray, exam: "", class: "", section: "", examCategoryData: [], marksArray: [], qbsearchsubject: [], examType: "", sectionValue: [], branchError: "", classError: "", examError: "", sectionError: "", getClasses: [], classError: "", examNameError: "", examTypeError: "", getSections: [], sectionValue: [], StudentsMarksData: [] })
            } else {
                this.setState({ branch: "", getExams: [], exam: "", class: "", section: "", examCategoryData: [], marksArray: [], qbsearchsubject: [], examType: "", sectionValue: [], branchError: "", classError: "", examError: "", sectionError: "", getClasses: [], classError: "", examNameError: "", examTypeError: "", getSections: [], sectionValue: [], StudentsMarksData: [] })

            }
        }

        if (name == "exam") {

            if (value != "0") {

                // Class options come from getBranches (the selected branch's sections),
                // not globals. Class labels are still resolved from globals.educationalClasses.
                const selBranchForClass = (this.props.branches || []).find((b) => String(b.id) == String(this.state.branch));
                const classSections = (selBranchForClass && selBranchForClass.sections) || [];
                let uniqueClasses = [...new Set(classSections.map((s) => s.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    if (!individualClassData) return;
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    getClasses: getArray,
                    branchError: "",
                    classError: "",
                    examError: "",
                    exam: value,
                    class: "",
                    section: "",
                    sectionError: "",
                    sectionValue: [],
                    getSections: [],
                    examCategoryData: [],
                    marksArray: [],
                    qbsearchsubject: [],
                    examType: "",
                    examTypeError: "",
                    StudentsMarksData: []
                })
            } else {
                this.setState({
                    getClasses: [],
                    branchError: "",
                    classError: "",
                    examError: "",
                    exam: "",
                    class: "",
                    section: "",
                    sectionError: "",
                    sectionValue: [],
                    getSections: [],
                    examCategoryData: [],
                    marksArray: [],
                    qbsearchsubject: [],
                    examType: "",
                    examTypeError: "",
                    StudentsMarksData: []
                })
            }

        }

        if (name == "class") {

            if (value != "0") {

                // Section options come from getBranches (the selected branch's sections
                // for the chosen class), not globals.
                const selBranchForSection = (this.props.branches || []).find((b) => String(b.id) == String(this.state.branch));
                const branchSections = (selBranchForSection && selBranchForSection.sections) || [];
                const seenSec = new Set();
                branchSections
                    .filter((s) => String(s.class_id) == String(value))
                    .forEach((s) => {
                        if (seenSec.has(String(s.id))) return;
                        seenSec.add(String(s.id));
                        getArray.push({ value: s.id, label: s.section_name });
                    })

                let sections = getArray.map((item) => item.value).toString();
                this.setState({ class: value, getSections: getArray, examCategoryData: [], marksArray: [], qbsearchsubject: [], examType: "", sectionValue: getArray, classError: "", sectionError: "", section: sections, StudentsMarksData: [] });

                this.getExamCategories(value)
            } else {
                this.setState({ class: "", getSections: [], examCategoryData: [], marksArray: [], qbsearchsubject: [], examType: "", classError: "", sectionError: "", sectionValue: [], section: "", examTypeError: "", StudentsMarksData: [] })
            }

        }


        if (name == "examType") {

            if (value != "0") {

                let filterExamCategories = this.state.examCategoryData.filter((item) => item.id == value);
                if (filterExamCategories[0].total_marks.length > 0) {

                    let marksArray = [];
                    let qbsearchsubject = [];

                    filterExamCategories[0].total_marks.map((item) => {

                        let subjectName = this.props.globals.offlineExamSubjects.filter((item1) => item1.id == item.subject_id);
                        marksArray.push({ ...item, subject_name: subjectName[0].subject });
                        qbsearchsubject.push(item.subject_id)
                    })
                    this.setState({ marksArray, qbsearchsubject, examType: value, examTypeError: "", StudentsMarksData: [] })
                }
            } else {
                this.setState({ marksArray: [], qbsearchsubject: [], examType: "", examTypeError: "", StudentsMarksData: [] })
            }
        }
    };

    handleNameChange = (event) => {
        this.setState({
            examName: event.target.value,
            examNameError: ""

        })
    }

    datefunction = (moment1, name) => {
        console.log("datefunction", moment1._d, name);
        let date = String(moment1._d);
        var res = date.substr(4, 20);
        this.setState({ startdate: res });

        this.setState({
            submitError1: ""
        });
    }

    // The Excel marks pick. It only parses into local state (nothing hits the server
    // until handleFormSubmit), but this IS the upload the module is named for, so it's
    // gated. The input stays enabled; the parse is what gets stopped.
    handleFileChange = e => {
        if (!this.guard.requireEdit()) {
            if (e && e.target) e.target.value = "";
            return;
        }

        console.log("eeee", e);

        this.setState({
            fileError: ""
        });


        this.setState({
            StudentsFilterData: [],
            cols: []
        });
        let fileObj = e.target.files[0];
        let fileType = ['application/vnd.ms-excel'];

        if (!fileType.includes(fileObj.type)) {
            this.setState({
                fileError: "Invalid Format"
            });
            return ""
        }

        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {


            console.log("rowwwww", resp.rows);
            if (err) {
                console.log(err);
            }
            else {
                let studentMarksData = []

                if (resp.rows) {
                    let rowData = resp.rows.slice(1);

                    if (rowData) {
                        rowData.map(item => {
                            console.log("res", item);
                            this.state.marksArray.map((item2, index) => {
                                studentMarksData.push({ student_mobile: item[1].toString(), subject_id: item2.subject_id, marks: item[index + 3] })
                            })
                        });
                    }
                }
                this.setState({
                    StudentsMarksData: studentMarksData,
                    fileError: ""
                });
            }
        });

    }


    getExamCategories = async (val) => {
        console.log("heeeee");
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int){
                getInstituteExamCategories(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id){
                    id
                    total_marks
                    exam_category_name
                    branch_id
                    exam_id
                    class_id
                    branch_name
                    class_name
                    exam_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(val)

            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getInstituteExamCategories.length > 0) {

            let data = result.data.getInstituteExamCategories;
            this.setState({ examCategoryData: data })
        } else {
            this.setState({ examCategoryData: [], marksArray: [], qbsearchsubject: [], examType: "" })
        }
    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("handleMultipleSelectInputChange", e, name);

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let handlemarksArray = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    console.log("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    const marksObj = {
                        subject_id: qbtopicval.value,
                        total_marks: 0
                    }

                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                    handlemarksArray.push(marksObj)
                }
                this.setState({
                    subjectValue: qbsearchtopicvalue,
                    qbsearchsubject: qbsearchtopic,
                    marksArray: handlemarksArray
                });
            }
        } else {
            let section = "";
            if (e.length > 0) {
                section = e.map((item) => item.value).toString()
            };
            this.setState({
                sectionValue: e,
                sectionError: "",
                section
            });
        }
    }

    handleMarksChange = async (e, id) => {
        const name = e.target.name;
        const value = e.target.value

        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        await delay(100);

        console.log("handleMarksChange", name, value, id)

        let array = [];

        if (value < 0) {
            this.setState({ marksError: "Please enter valid marks" })
            return ""
        } else {
            this.setState({ marksError: "" })
        }

        this.state.marksArray.map((item) => {
            console.log("item", item)
            if (item.subject_id == id) {
                array.push({ ...item, total_marks: parseInt(value) })
            } else {
                array.push({ ...item })
            }
        })
        this.setState({ marksArray: array })
    }

    handleFormSubmit = e => {
        // Checked BEFORE btn_disabled is set: an early return after that line would leave
        // the Submit button permanently disabled for a denied role.
        if (!this.guard.requireEdit()) return;

        this.setState({ btn_disabled: true })

        if (this.state.branch == "") {
            this.setState({ branchError: "Please select Branch", btn_disabled: false })
            return ""
        }

        if (this.state.exam == "") {
            this.setState({ examError: "Please select Exam", btn_disabled: false })
            return ""
        }

        if (this.state.class == "") {
            this.setState({ classError: "Please select Class", btn_disabled: false })
            return ""
        }
        if (this.state.section == "") {
            this.setState({ sectionError: "Please select Section", btn_disabled: false })
            return ""
        }
        if (this.state.examName == "") {
            this.setState({ examNameError: "Please give Exam name", btn_disabled: false })
            return ""
        }

        if (this.state.examType == "") {
            this.setState({ examTypeError: "Please select Exam type", btn_disabled: false })
            return ""
        }
        if (this.state.startdate == "") {
            this.setState({ dateError: "Please select Date", btn_disabled: false })
            return ""
        }

        this.state.marksArray.map((item) => {
            if (item.total_marks == 0 || item.total_marks == NaN) {
                this.setState({ marksError: "Please enter marks", btn_disabled: false })
                return ""
            }
        })

        if (this.state.StudentsMarksData.length == 0) {
            this.setState({ fileError: "Invalid data", btn_disabled: false })
            return ""
        }


        e.preventDefault();



        let marks = [];

        this.state.marksArray.map((item) => {

            marks.push({ subject_id: item.subject_id, total_marks: item.total_marks })

        })


        let submitAccess = false;

        this.state.StudentsMarksData.map((item) => {
            console.log("number", typeof item.marks);
            if (item.student_mobile == undefined) {
                this.setState({ fileError: "Invalid Data", btn_disabled: false });
                submitAccess = true
                return "";
            } else if (item.subject_id == undefined) {
                this.setState({ fileError: "Invalid Data", btn_disabled: false });
                submitAccess = true;
                return "";
            } else if (item.marks == undefined || typeof item.marks != "number") {
                this.setState({ fileError: "Invalid Data", btn_disabled: false });
                submitAccess = true;
                return "";
            }
        })

        if (submitAccess) {
            return ""
        }


        let params = {
            paper_name: this.state.examName.toString(),
            class_id: parseInt(this.state.class),
            exam_id: parseInt(this.state.exam),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            section_id: this.state.section.toString(),
            exam_category_id: parseInt(this.state.examType),
            subject_ids: this.state.qbsearchsubject.toString(),
            exam_date: this.state.startdate.toString(),
            total_marks: marks,
            student_marks_Data: this.state.StudentsMarksData
        };

        console.log("params", params);

        this.addOfflineStudentResults(params).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message), btn_disabled: false
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)
            );
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    };

    // Last gate before addOfflineStudentResults leaves the client.
    addOfflineStudentResults = async params => {
        if (!this.guard.requireEdit()) return;

        console.log("child");
        await this.props.addOfflineStudentResults({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addOfflineStudentResults) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false);
    };

    handleDateChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "startdate") {
            this.setState({ startdate: Math.floor(new Date(value).getTime() / 1000), dateError: "" })

        }
    }

    render() {

        console.log("mahesh", this.state);

        let currentDate = new Date().toJSON().slice(0, 10);

        if (this.props.globals == undefined) return null;

        // Restrict the branch dropdown to branches the logged-in user is authorized for.
        // The branch_id cookie holds them as a comma-separated list (e.g. "10,12,15").
        let branchList = this.props.globals.globalBranches || [];
        const authorizedIds = getAuthorizedBranchIds();
        if (authorizedIds.length) {
            branchList = branchList.filter((item) => authorizedIds.includes(String(item.id)));
        }


        let subjectSelectAll = true;
        let subjectlabelledby = "Select";
        let subjectdisablesearch = false;
        if (this.state.offlinesubjectsArray.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectlabelledby = "Subjects"
        }

        let sectionSelectAll = true;
        let sectionlabelledby = "Select";
        let sectiondisablesearch = false;
        if (this.state.getSections.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionlabelledby = "Sections"
        }

        return (
            <>
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Exam</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{ minHeight: "400px" }}>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase">Branch</Form.Label>
                                <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                    <option value={this.state.defaultvalue}>--Select Branch--</option>
                                    {branchList.map(branchData => (
                                        <option value={branchData.id}>{branchData.branch_name}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.branchError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="Selectexam">
                                <Form.Label className="text-uppercase">Exam</Form.Label>
                                <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                    <option value={this.state.defaultvalue}>--Select Exam--</option>
                                    {this.state.getExams.map(item => (
                                        <option value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.examError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase">Class</Form.Label>
                                <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class}>
                                    <option value={this.state.defaultvalue}>--Select class--</option>
                                    {this.state.getClasses.map(classdata => (
                                        <option value={classdata.value}>{classdata.label}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.classError}
                                </Form.Text>
                            </Form.Group>


                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectSection"  >
                                <Form.Label className="text-uppercase">Section</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Sections are selected.",
                                        "selectSomeItems": sectionlabelledby
                                    }
                                    }
                                    disableSearch={sectiondisablesearch}
                                    hasSelectAll={sectionSelectAll}
                                    options={this.state.getSections}
                                    value={this.state.sectionValue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                    labelledBy={"Sections"}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.sectionError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="examName">
                                <Form.Label className="text-uppercase">Exam Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Exam Name"
                                    name="exam_name"
                                    autoComplete="off"
                                    className='custom_selection'
                                    onChange={(e) => this.handleNameChange(e)}
                                    value={this.state.examName}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.examNameError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="Selectexam">
                                <Form.Label className="text-uppercase">Exam Type</Form.Label>
                                <Form.Control as="select" name="examType" onChange={this.handleInputChange} value={this.state.examType}>
                                    <option value={this.state.defaultvalue}>--Select Exam Type--</option>
                                    {this.state.examCategoryData.map(examtype => (
                                        <option value={examtype.id}>{examtype.exam_category_name}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.examTypeError}
                                </Form.Text>
                            </Form.Group>



                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="startdate" className="mbottom_5">
                                <Form.Label className="text-uppercase"> Exam date</Form.Label>
                                <input
                                    type="date"
                                    name="startdate"
                                    onChange={(e) => this.handleDateChange(e)}
                                    className="custom_selection bd_wid"
                                    placeholder=""
                                />

                                <Form.Text className="form-text text-danger">
                                    {this.state.dateError}
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                        {
                            this.state.subjectValue.length > 0 ?
                                (
                                    <Form.Row>
                                        <Form.Label>Enter Subject wise Total Marks</Form.Label>

                                    </Form.Row>
                                )
                                :
                                ("")
                        }

                        <Form.Row className="">
                            {
                                this.state.marksArray.length > 0 ?
                                    (
                                        <>

                                            {

                                                this.state.marksArray.map((e, i) => {
                                                    let subjectName = this.props.globals.offlineExamSubjects.filter((item) => item.id == e.subject_id);
                                                    return (
                                                        <>
                                                            <Form.Group as={Col} lg={3} md={12} sm={12} className="mb-2">
                                                                <p>{subjectName[0]?.subject} Marks</p>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder=""
                                                                    name="termsFeeInput"
                                                                    autoComplete="off"
                                                                    className='custom_selection'
                                                                    // onChange={(e) => this.handleMarksChange(e, i + 1)}
                                                                    value={e.total_marks}
                                                                    disabled="true"
                                                                    min="1"
                                                                />
                                                            </Form.Group>
                                                        </>
                                                    )
                                                })

                                            }

                                            <Form.Text className="form-text text-danger">
                                                {this.state.marksError}
                                            </Form.Text>
                                        </>
                                    )
                                    :
                                    ("")
                            }
                        </Form.Row>
                    </Form>

                    {
                        this.state.exam != "" && this.state.branch != "" && this.state.examType != "" && this.state.section != "" && this.state.examName != "" && this.state.qbsearchsubject.length > 0 && this.state.class != "" && this.state.startdate != "" ?
                            (
                                <>
                                    <Row>
                                        <Col sm={6} lg={6} md={6}>
                                            <MarksExcelContainer stateData={this.state} />
                                        </Col>
                                        <Col sm={6}>
                                            <Form.Group controlId="formFile" as={Col}
                                                lg={12}
                                                md={12}
                                                sm={12}>
                                                <Form.Control name="file" type="file" onChange={this.handleFileChange} >
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger">
                                                    {this.state.fileError}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                </>
                            )
                            :
                            ("")
                    }

                </Modal.Body>

                <Modal.Footer variant="white" className="px-4">

                    <Row>
                        <Col sm={12}>
                            {this.state.currentStep == 5 ? (
                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                    Marks uploaded successfully
                                </Form.Text>
                            ) : (
                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                    {this.state.submitError}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>

                            <Button onClick={this.handleFormSubmit}  className="examPattern_btn" disabled={this.state.btn_disabled} style={this.state.isSubmitting == true ? { cursor: "not-allowed" } : { cursor: "pointer" }}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }
                                Submit</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            {/* Sibling of the form Modal (not nested) so it can stack above it when a
                submit or excel pick is intercepted. */}
            <AccessDeniedModal
                show={this.state.accessDeniedShow}
                onHide={this.guard.hideAccessDenied}
            />
            </>
        );
    }
}


export default withRouter(withApollo(compose(
    graphql(ADD_Marks, {
        name: "addOfflineStudentResults"
    }),
)(CreateExamModal))
);
